export default __webpack_public_path__ + "static/media/retailer-density.593d6cef.svg";